import {ElMessage} from 'element-plus';


export function msgOnErr<T extends Function>(fn: T): T {
  return async function () {
    try {
      return await fn(...arguments);
    } catch (e) {
      console.error(e);
      const bizMsg = e.bizMsg || '操作失败';
      ElMessage.error(bizMsg);
    }
  } as any;
}
